import { START_LOCATION } from 'vue-router'
import type {
  RouteLocationNormalized,
  RouteLocationNormalizedLoaded,
} from 'vue-router'

import { sendPageLoad } from '@/plugins/analytics'
import { recordDeeplinkClick } from '@/utils/recordDeeplinkClick'

export const handleAfterEach = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded
): void => {
  if (to?.name && typeof to.name === 'string') sendPageLoad(to.name)
  // Internal SPA navigation (e.g. opening an Inbox thread) must not be counted as a deeplink click.
  if (from === START_LOCATION) recordDeeplinkClick(window.location.href)
}
